import React from 'react'
import HomeBanner from '../components/Home/HomeBanner'
import WorkExp from '../components/Home/WorkExp'
import ServiceOffer from '../components/Home/ServiceOffer'
import AboutUs from '../components/Home/AboutUs'

const Home = () => {
  return (
    <div>
      <HomeBanner />
      <WorkExp />
      <ServiceOffer />

      <AboutUs />
    </div>
  )
}

export default Home
